import React from 'react';
import styled from 'styled-components';
import DOMPurify from 'dompurify';

type YoutubeEmbedProps = {
  id: string;
  width?: number;
  height?: number;
};

const YoutubeEmbed: React.FC<YoutubeEmbedProps> = ({ id, width = 800, height = 450 }) => {
  const dimensionPadding = (height / width) * 100;

  const isPlaylist = id.startsWith('PL');
  const embedUrl = isPlaylist ? `https://www.youtube.com/embed/?list=${id}` : `https://www.youtube.com/embed/${id}`;

  const embedCode = `<iframe loading="lazy" width="${width}" height="${height}" src="${embedUrl}" frameBorder="0" allowfullscreen></iframe>`;
  const sanitizedEmbedCode = DOMPurify.sanitize(embedCode, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen', 'loading', 'frameborder', 'src', 'width', 'height'],
  });

  return <EmbedStyled padding={dimensionPadding} dangerouslySetInnerHTML={{ __html: sanitizedEmbedCode }} />;
};

type EmbedStyleProps = {
  padding: number;
};

const EmbedStyled = styled.div<EmbedStyleProps>`
  width: 100%;
  position: relative;
  padding-bottom: ${(props) => props.padding}%;
  height: 0;
  overflow: hidden;
  margin: 1.5rem 0;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default YoutubeEmbed;
